<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl mb-0 card font-bold">
                  Customer Details (Mobile App)
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="">
                <Breadcrumb
                  :home="{
                    icon: 'pi pi-arrow-left text-lg mr-3',
                    label: 'Back',
                    command: () => {
                      $router.go(-1);
                    },
                  }"
                  :model="[
                    {
                      label: 'Customer Details (Mobile App)',
                      to: '/complaints',
                    },
                  ]"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>
    <section class="page-section pt-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="col-12 md:col-5 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <div class="relative-position" style="min-height: 100px">
                    <template v-if="pageReady">
                      <div class="grid">
                        <div class="col">
                          <div class="" :class="{ card: !isSubPage }">
                            <div class="grid align-items-center">
                              <div class="col">E-Billing Customer ID:</div>
                              <div class="col font-bold">
                                {{ item.gwcl_user_id }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Name:</div>
                              <div class="col font-bold">{{ item.name }}</div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Phone Number:</div>
                              <div class="col font-bold">
                                {{ item.phone_number }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Device Platform:</div>
                              <div class="col font-bold">
                                {{ $utils.upper(item.device_platform) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Digital Address:</div>
                              <div class="col font-bold">
                                {{ item.digital_address }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Otp Sent to Customer:</div>
                              <div class="col font-bold">
                                {{ item.otp_key }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Date Created:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_created) }}
                              </div>
                            </div>
                            <hr />
                            <div class="grid align-items-center">
                              <div class="col">Last Updated:</div>
                              <div class="col font-bold">
                                {{ $utils.humanDatetime(item.date_updated) }}
                              </div>
                            </div>
                            <hr />
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="loading">
                      <div>
                        <table class="p-datatable-table w-full">
                          <tbody>
                            <tr v-for="n in 8" :key="n">
                              <td class="text-left" style="width: 100%">
                                <Skeleton height="3rem" class="m-2" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-7 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <MetersListPage
                    ref="metersListPage"
                    :limit="3"
                    field-name="meters.customer_id"
                    :field-value="id"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </MetersListPage>
                </div>
              </div>
              <div class="">
                <div>
                  <PaymentHistorySublistPage
                    ref="paymentHistoryListPage"
                    :limit="3"
                    field-name="payment_history.msisdn"
                    :field-value="item.phone_number"
                    :show-header="true"
                    :show-breadcrumbs="true"
                    :show-footer="true"
                    :paginate="true"
                    v-if="pageReady"
                  >
                  </PaymentHistorySublistPage>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { defineAsyncComponent, computed, toRefs, onMounted } from "vue";
import { utils } from "@/utils";
import { useApp } from "@/composables/app.js";
import { useViewPage } from "@/composables/viewpage.js";
import MetersListPage from "../meters/list.vue";
import PaymentHistorySublistPage from "../payment_history/sublist.vue";
const props = defineProps({
  id: [String, Number],
  primaryKey: {
    type: String,
    default: "customer_id",
  },
  pageName: {
    type: String,
    default: "customers",
  },
  routeName: {
    type: String,
    default: "customersview",
  },
  apiPath: {
    type: String,
    default: "customers/view",
  },
  editButton: {
    type: Boolean,
    default: true,
  },
  deleteButton: {
    type: Boolean,
    default: true,
  },
  exportButton: {
    type: Boolean,
    default: true,
  },
  titleBeforeDelete: {
    type: String,
    default: "Delete record",
  },
  msgBeforeDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  msgAfterDelete: {
    type: String,
    default: "Record deleted successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showFooter: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp(props);
const page = useViewPage(props); // page hook
//page state
const {
  item, // current record from store - Object
  loading, // api loading state
  pageReady, // api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // load data from api
  deleteItem, // deleted current record
  exportPage, // export page records - args = (exportFormats, apiUrl, pageName)
  moveToNextRecord, // load next record from api
  moveToPreviousRecord, // load previous record from api
} = page.methods;
function getActionMenuModel(data) {
  return [];
}
onMounted(() => {
  const pageTitle = "Customers Details";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
